export const LOADING = "loading";
export const NORMAL = "normal";
export const PARTICIPANTS = "participants";
